import { render, staticRenderFns } from "./ModalEditContact.vue?vue&type=template&id=56f74306&"
import script from "./ModalEditContact.vue?vue&type=script&lang=js&"
export * from "./ModalEditContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports